// @ai-generated 2026-08-05T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
import { IconArrowFork, IconArrowMerge } from '@tabler/icons-react';
import { useState } from 'react';
import type { SynqoAndCondition, SynqoOrCondition, SynqoRuleset } from '@Model';
import { ACCENT } from './accent';
import { ConditionCard, ConditionCardHeader } from './ConditionCard';
import { ConditionVisitor } from './ConditionVisitor';

interface LogicalGroupRendererProps {
    node: SynqoAndCondition | SynqoOrCondition;
    referencedRulesets: Record<string, SynqoRuleset>;
}

export function LogicalGroupRenderer({ node, referencedRulesets }: LogicalGroupRendererProps) {
    const [expanded, setExpanded] = useState(true);
    const isAnd = node.type === 'and';
    const keyword = isAnd ? 'Alle' : 'Mindestens eine';
    const trailingText = isAnd ? 'müssen zutreffen' : 'muss zutreffen';
    const accent = isAnd ? ACCENT.and : ACCENT.or;
    const Icon = isAnd ? IconArrowMerge : IconArrowFork;
    const childCount = node.children.length;

    return (
        <ConditionCard accent={accent}>
            <ConditionCardHeader
                expanded={expanded}
                onToggle={() => setExpanded((prev) => !prev)}
                icon={<Icon size={16} className={`shrink-0 ${accent.icon}`} />}
                title={
                    <>
                        <span className="text-(--mantine-color-primary-text) font-semibold">{keyword}</span>{' '}
                        <span className="text-(--mantine-color-text-5)">{trailingText}</span>
                    </>
                }
                trailing={
                    <span className="font-normal text-(--mantine-color-text-4)">
                        ({childCount} {childCount === 1 ? 'Bedingung' : 'Bedingungen'})
                    </span>
                }
            />
            {expanded && (
                <div className="mt-2 flex flex-col gap-2 pl-1">
                    {node.children.map((child, index) => (
                        <ConditionVisitor
                            key={`${child.type}-${index}`}
                            node={child}
                            referencedRulesets={referencedRulesets}
                        />
                    ))}
                </div>
            )}
        </ConditionCard>
    );
}
